import type { JSX } from "react";
import { useEffect, useId, useRef } from "react";

export type MermaidDiagramProps = {
  chart: string;
  title?: string;
};

export function MermaidDiagram(props: MermaidDiagramProps): JSX.Element {
  const container = useRef<HTMLDivElement>(null);
  const id = useId().replace(/:/g, "-");

  useEffect(() => {
    let active = true;

    void import("mermaid").then(async ({ default: mermaid }) => {
      mermaid.initialize({ securityLevel: "strict", startOnLoad: false });
      const { svg } = await mermaid.render(`mermaid-${id}`, props.chart);
      if (active && container.current) container.current.innerHTML = svg;
    });

    return () => {
      active = false;
    };
  }, [id, props.chart]);

  return <div aria-label={props.title ?? "Mermaid diagram"} ref={container} role="img" />;
}
